import React from 'react';
import {get} from 'lodash';

import SectionHeader from '/component/base/SectionHeader';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

interface OrdersListHeaderProps {
  tt: (key: string, callback: any) => string;
  loadingData: {
    total: number;
  } | null;
  reportMeta: {
    page: {
      total: number;
    };
  } | null;
  reportName: string;
  reportIsLoading: boolean;
}

export const OrdersListHeader: React.FC<OrdersListHeaderProps> = ({
  tt = withTranslation.ttDefaultProp,
  loadingData = null,
  reportMeta = null,
  reportName = '',
  reportIsLoading = true,
}: OrdersListHeaderProps) => {
  const total = get(reportMeta, 'page.total', get(loadingData, 'total', ''));

  return (
    <SectionHeader
      reportName={reportName}
      reportIsLoading={reportIsLoading}
      reportMeta={reportMeta}
      loadingData={loadingData}
      allowFontScaling
      maxFontSizeMultiplier={2}>
      {tt(
        'totalOrdersCount',
        generateComponentCallback({
          component: (
            <>
              {total} {parseInt(total, 10) === 1 ? 'Order' : 'Orders'}
            </>
          ),
        }),
      )}
    </SectionHeader>
  );
};

export default withTranslation('report.list.ordersHeader')(OrdersListHeader);
